const MOBIL_ELOTAGOK = ['20', '30', '31', '50', '70'];

export type TelefonEredmeny =
  | { ok: true; e164: string }
  | { ok: false };

/** Magyar mobilszámot normalizál. Vezetékes és külföldi számot elutasít (spec 10. pont). */
export function huMobilNormalizalas(bemenet: string): TelefonEredmeny {
  const s = bemenet.replace(/[\s\-()/.]/g, '');
  let nemzeti: string | null = null;
  if (/^\+36\d{9}$/.test(s)) nemzeti = s.slice(3);
  else if (/^0036\d{9}$/.test(s)) nemzeti = s.slice(4);
  else if (/^06\d{9}$/.test(s)) nemzeti = s.slice(2);
  else if (/^36\d{9}$/.test(s)) nemzeti = s.slice(2);
  else if (/^\d{9}$/.test(s)) nemzeti = s;
  if (nemzeti === null || !MOBIL_ELOTAGOK.includes(nemzeti.slice(0, 2))) return { ok: false };
  return { ok: true, e164: `+36${nemzeti}` };
}
